import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/game/ae_game_banner.webp";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Banner(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div
        className="service_usa web_dev_service healthcare_banner android_banner"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={9} lg={9} xl={8} xxl={7} className="my-auto">
              <div className="banenr_content">
                <h1
                  className="web_head_banner"
                  style={{ marginBottom: "10px" }}
                >
                  Game Development Company in Dubai
                </h1>
                <span style={{ color: "#fff" }} className="d-block mb-3">
                  Premier Game App Development Company UAE
                </span>
                <p>
                  TekRevol stands as one of the pioneering trendsetters in
                  mobile game app development in the UAE. We focus in crafting
                  trailblazing mobile games that not only dominate app stores
                  but also reform your gaming experience. Our assurance is to
                  provide a new viewpoint on modern gaming, projecting the next
                  big trend. Team up with us, and unleash a world where
                  immersive gameplay and novelty meet, propelling your mobile
                  gaming journey on the path to unmatched success.
                </p>

                <button
                  style={{ background: "#F47a14", color: "#fff" }}
                  onClick={handleShow}
                  className="border_btn"
                >
                  Let’s Get Started!
                </button>
              </div>
            </Col>
            {/* <Col xs={12} md={5} lg={6} xl={5} xxl={5} className="my-auto">
              <Bannerfrom />
            </Col> */}
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Banner;
